import { Model } from './model';

export class User extends Model {

  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  enabled?: boolean;
  role?: "admin" | 'customer' | 'logistic' | 'researcher' | 'tester';
  cognitoId?: string;
  userStatus?: string;

}

